import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { CabeceraMarca } from './componentes/Piezas';
import './estilos.css';
import { Acceso, Revisa } from './paginas/Acceso';
import { Confirmada } from './paginas/Confirmada';
import { MiSesion } from './paginas/MiSesion';
import { Pago } from './paginas/Pago';
import { Reprogramar } from './paginas/Reprogramar';
import { Reservar } from './paginas/Reservar';

function NoEncontrada() {
  return (
    <div className="pantalla">
      <CabeceraMarca />
      <div className="contenido">
        <h1 className="titulo">Esta página no existe</h1>
        <Link to="/" className="boton">
          Ir al inicio
        </Link>
      </div>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Reservar />} />
      <Route path="/dia/:fecha" element={<Reservar />} />
      <Route path="/pago/:id" element={<Pago />} />
      <Route path="/confirmada/:id" element={<Confirmada />} />
      <Route path="/acceso" element={<Acceso />} />
      <Route path="/revisa" element={<Revisa />} />
      <Route path="/mi-sesion" element={<MiSesion />} />
      <Route path="/reprogramar/:id" element={<Reprogramar />} />
      <Route path="*" element={<NoEncontrada />} />
    </Routes>
  );
}

const raiz = document.getElementById('raiz');
if (raiz) {
  createRoot(raiz).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
